import React from 'react'
import { IRichTextEditorProps, RichTextEditor } from './RichTextEditor'

type IProps = Omit<IRichTextEditorProps, 'extensions' | 'defaultButton' | 'onSelectOrDropFiles'>

export const WaiverEditor = ({ ...props }: IProps) => (
  <RichTextEditor {...props} extensions={['starter', 'align']} />
)
